import { useUnlayerTemplatesEditorContext } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/UnlayerTemplatesEditorView/UnlayerTemplatesEditorContext';
import {
	Button,
	CircularProgress,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField,
} from '@mui/material';
import React from 'react';

const SaveAsDialog = () => {
	const {
		labels,
		dialogs,
		patchDialog,
		isCreatingTemplate,
		isUpdatingTemplate,
		isDeletingTemplate,
		isSharingTemplate = false,
		handleSaveAsTemplate,
	} = useUnlayerTemplatesEditorContext();

	const saveAs = dialogs.saveAs;
	const isSaving =
		isCreatingTemplate || isUpdatingTemplate || isDeletingTemplate || isSharingTemplate;

	return (
		<Dialog
			open={saveAs.open}
			onClose={() => patchDialog('saveAs', { open: false })}
			fullWidth
			maxWidth='sm'
		>
			<DialogTitle>{labels.saveAsDialogTitle}</DialogTitle>
			<DialogContent>
				<DialogContentText sx={{ mb: 2 }}>{labels.saveAsDialogBody}</DialogContentText>
				<TextField
					autoFocus
					label={labels.saveAsNameLabel}
					value={saveAs.name}
					onChange={(event) => {
						patchDialog('saveAs', {
							name: event.target.value,
							...(saveAs.error ? { error: '' } : {}),
						});
					}}
					error={Boolean(saveAs.error)}
					helperText={saveAs.error || ' '}
					fullWidth
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={() => patchDialog('saveAs', { open: false })}>Cancel</Button>
				<Button variant='contained' onClick={handleSaveAsTemplate} disabled={isSaving}>
					{isCreatingTemplate ? <CircularProgress size={18} /> : labels.saveAsButton}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
export default SaveAsDialog;
